export const handlePermissionError = (location?) => {
  const locationInterface = location || window.location
  locationInterface.replace('/permission-denied')
}
